export default __webpack_public_path__ + "bc2c9e9d67b73656a6da5dd177aa10a2.svg";